module.exports = __webpack_public_path__ + "resources/img/img_dataflow_en.252f048f34ab7e27ac6bc69fc81ebe72.png";